// Shared RouteOps helpers
export const ROUTE_ORDER = ['ne', 'se', 'sw', 'nw', 'hgv1', 'hgv2'];

export const VEHICLE_TYPES = [
  { value: '7.5T Curtainsider', payload: 3500 },
  { value: '7.5T Box', payload: 3500 },
  { value: '7.5T Flatbed', payload: 3500 },
  { value: '18T Curtainsider', payload: 12000 },
  { value: '44T Artic Curtainsider', payload: 24000 },
  { value: '44T Artic Box', payload: 24000 },
];

export function fmtKg(n) {
  if (n == null) return '—';
  return new Intl.NumberFormat('en-GB').format(Math.round(n)) + ' KG';
}

export function fmtKgShort(n) {
  if (n == null) return '—';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'T';
  return Math.round(n) + 'KG';
}

export function getWeekStart(d = new Date()) {
  const copy = new Date(d);
  const day = copy.getDay(); // 0 Sun - 6 Sat
  const diff = (day === 0 ? -6 : 1 - day); // shift to Monday
  copy.setDate(copy.getDate() + diff);
  copy.setHours(0, 0, 0, 0);
  return copy;
}

export function addDays(d, n) {
  const c = new Date(d);
  c.setDate(c.getDate() + n);
  return c;
}

export function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function fmtDayLabel(d) {
  return d.toLocaleDateString('en-GB', { weekday: 'short' });
}

export function fmtDate(d) {
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' });
}

export function fmtDateLong(d) {
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function fmtTs(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function getRouteColorClass(key) {
  const map = {
    ne: 'bg-purple-500',
    se: 'bg-sky-500',
    sw: 'bg-emerald-500',
    nw: 'bg-amber-500',
    hgv1: 'bg-red-500',
    hgv2: 'bg-teal-500',
  };
  return map[key] || 'bg-slate-400';
}

export function getLoadTone(totalKg, maxKg, thresholdPct = 10) {
  if (!maxKg) return 'ok';
  const pct = (totalKg / maxKg) * 100;
  if (totalKg > maxKg) return 'over';
  if (pct >= (100 - thresholdPct)) return 'warn';
  return 'ok';
}

export function toneBadgeClass(tone) {
  switch (tone) {
    case 'over': return 'bg-red-100 text-red-700 border-red-200';
    case 'warn': return 'bg-amber-100 text-amber-700 border-amber-200';
    default: return 'bg-emerald-100 text-emerald-700 border-emerald-200';
  }
}

export function categoryBadgeClass(cat) {
  switch (cat) {
    case 'Bookings': return 'bg-sky-100 text-sky-700 border-sky-200';
    case 'Terminal': return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'Route Config': return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    case 'Assignments': return 'bg-indigo-100 text-indigo-700 border-indigo-200';
    case 'Notes': return 'bg-purple-100 text-purple-700 border-purple-200';
    case 'AI': return 'bg-cyan-100 text-cyan-700 border-cyan-200';
    case 'System': return 'bg-slate-100 text-slate-700 border-slate-200';
    case 'Auth': return 'bg-teal-100 text-teal-700 border-teal-200';
    default: return 'bg-slate-100 text-slate-700 border-slate-200';
  }
}

export function statusBadgeClass(status) {
  switch (status) {
    case 'Unassigned': return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'Assigned': return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    case 'Overweight': return 'bg-red-100 text-red-700 border-red-200';
    case 'Picking': return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'Out for Delivery': return 'bg-sky-100 text-sky-700 border-sky-200';
    case 'Completed': return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    default: return 'bg-slate-100 text-slate-700 border-slate-200';
  }
}

export function downloadJson(data, filename) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(a.href);
}

export function downloadCsv(rows, headers, filename) {
  const esc = v => {
    if (v == null) return '';
    const s = String(v);
    if (s.includes(',') || s.includes('"') || s.includes('\n')) {
      return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
  };
  const lines = [headers.map(h => esc(h.label)).join(',')];
  for (const r of rows) {
    lines.push(headers.map(h => esc(typeof h.get === 'function' ? h.get(r) : r[h.key])).join(','));
  }
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(a.href);
}
